export default "assets/images/icons/youtube-a680c5b1.svg";